import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiMail } from "react-icons/fi";
import { FaTelegramPlane, FaDiscord } from "react-icons/fa";

// รายการ Contact
const contacts = [
  { name: "Email", icon: <FiMail size={30} />, link: "mailto:j.donlatam@gmail.com" },
  { name: "Telegram", icon: <FaTelegramPlane size={30} />, link: "https://t.me/justerlin" },
  { name: "Discord", icon: <FaDiscord size={30} />, link: "https://discord.com/users/326603470507474944" },
];

const FloatingContact = () => {
  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    // ให้ไอคอนบินเลี้ยวไปมา 2 วินาทีแล้วเข้ามุมขวาล่าง
    const timer = setTimeout(() => setStartAnimation(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end space-y-3">
      {contacts.map((contact, index) => (
        <motion.a
          key={index}
          href={contact.link}
          target="_blank"
          rel="noopener noreferrer"
          initial={{
            opacity: 0,
            x: -window.innerWidth / 2, // เริ่มจากซ้ายสุดของจอ
            y: Math.random() * 300 - 150, // สุ่มตำแหน่งแนวตั้ง
            scale: 0.5,
          }}
          animate={startAnimation
            ? {
                opacity: 1,
                scale: 1,
                x: [ -window.innerWidth / 2, -200, 50, 0 ], // เส้นทางโค้ง
                y: [ Math.random() * 300 - 150, Math.random() * 200 - 100, Math.random() * 150 - 75, 0 ],
              }
            : {}}
          transition={{
            duration: 2,
            delay: index * 0.3,
            ease: "easeInOut",
          }}
          whileHover={{
            rotate: 540, // หมุน 3 รอบ (540°)
            scale: 1.25, // ขยายขึ้นเล็กน้อย
            transition: { duration: 0.5, ease: "easeInOut" }, // ✅ เร็วขึ้นเป็น 0.5 วินาที
          }}
          className="text-gray-600 hover:text-gray-300 transition-transform"
        >
          {contact.icon}
        </motion.a>
      ))}
    </div>
  );
};

export default FloatingContact;
